<template>
    <EAK url="/api/v4/installations/disposals/types/:id"></EAK>
</template>

<script>
import EAK from '@/components/Installations/Disposal/EAK';

export default {
    components: {
        EAK
    }
}
</script>